/// <amd-module name="DistributedTaskUI/ServiceEndpoints/Editor/UIContributions/AzureRMEndpoint/Components/Manual/ARMEndpointFooterComponent" />
import React = require("react");
import { VssComponent } from "VSS/Platform/Layout";
import { ARMFooterLinks } from "../Common/ARMFooterLinks";
import { EndpointFooterComponent, IEndpointFooterComponentProps } from "../Common/EndpointFooterComponent";


export class ARMEndpointFooterComponent extends VssComponent<IEndpointFooterComponentProps> {

    public render(): JSX.Element {
        return (<EndpointFooterComponent
            renderButtons={this.props.renderButtons}
            renderLinks={() => <ARMFooterLinks />} />);
    }
}
